import React from "react";

import Button from "components/ui/button/Button";
import { appRoutes } from "lib/appRoutes";
import { RELEVANCY_SEARCH_NEW_USERS, useVariableValue } from "lib/featureFlags";
import Signal from "lib/icons/Signal";

import css from "./SignalEmptyState.module.scss";

type Props = {
  entity: string;
  message?: string;
};

function SignalEmptyState({ entity, message }: Props) {
  const isRelevancySearchEnabled = useVariableValue(RELEVANCY_SEARCH_NEW_USERS, false);
  return (
    <div className={css.emptyStateDropdown}>
      <div aria-label="Empty signal state" className={css.emptyStateContainer}>
        <div className={css.emptyStateTextContainer}>
          <b>{`You haven’t saved any ${entity}s yet`}</b>
          {message && <p>{message}</p>}
        </div>
        {!isRelevancySearchEnabled && (
          <Button
            as="a"
            aria-label="Signals settings button"
            className={css.signalSettingsBtn}
            {...appRoutes.feedSettings}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className={css.signalSettingsBtnContents}>
              <Signal fill="white" background="none" />
              Save {entity} signals
            </div>
          </Button>
        )}
      </div>
    </div>
  );
}

export default SignalEmptyState;
